import React from 'react';
import css from './ValidationMessage.module.css';
import Spinner from '../../../loadingSpinner/Spinner';
import { Image } from '../../../images';
import { ErrorImage, SuccessImage } from '../../../../assets/images';
import { SpinnerSize } from '../../../loadingSpinner/SpinnerSize';

export interface ValidationMessageProps {
  validating?: boolean;
  validatingMessage?: string;
  validMessage?: string;
  errorMessage?: string;
}

const ValidationMessage: React.FC<ValidationMessageProps> = (
  props: ValidationMessageProps
) => {
  const { validating = false } = props;
  return (
    <>
      {validating ? (
        <div className={css.validatingMessage}>
          <div>
            <Spinner size={SpinnerSize.Inline} />
          </div>
          <div>{props.validatingMessage}</div>
        </div>
      ) : props.errorMessage && props.errorMessage.length > 0 ? (
        <div className={css.errorMessage}>
          <div className={css.imageContainer}>
            <Image
              source={ErrorImage}
              alternateText="Error"
              width={16}
              height={16}
            />
          </div>
          <div>{props.errorMessage}</div>
        </div>
      ) : props.validMessage && props.validMessage.length > 0 ? (
        <div className={css.validMessage}>
          <div className={css.imageContainer}>
            <Image
              source={SuccessImage}
              alternateText="Valid"
              width={16}
              height={16}
            />
          </div>
          <div>{props.validMessage}</div>
        </div>
      ) : null}
    </>
  );
};

export default ValidationMessage;
